import { FC, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { MEDIA_QUERIES } from 'shared/styles/variables';
import { ThemeContext } from 'styled-components';

import useWindowDimensions from 'lib/hooks/useWindowDimensions';
import { ButtonPosition } from 'lib/interfaces/ThemeSerialized';
import Footer from 'verify/components/Footer';

const PositionableButtonContainer: FC<PropsWithChildren<object>> = ({ children }) => {
  const theme = useContext(ThemeContext);
  const [isSmallVertical, setIsSmallVertical] = useState(false);
  const { height } = useWindowDimensions();

  useEffect(() => {
    setIsSmallVertical(window.matchMedia(MEDIA_QUERIES.isSmallVertical).matches);
  }, [height]);

  switch (theme?.buttonPosition) {
    case ButtonPosition.Bottom:
      // Don't use sticky footer for very small devices, as buttons may cover important content.
      return isSmallVertical ? <>{children}</> : <Footer>{children}</Footer>;
    case ButtonPosition.Inline:
    default:
      return <>{children}</>;
  }
};

export default PositionableButtonContainer;
